import React from 'react';

const Physics = () => {
  return (
    <div>
      Physics
      Physics
    </div>
  );
}

export default Physics;
